import { Trans } from "react-i18next";
import { Icon } from "@/ui/icon/Icon";
import { useCalculator } from "../../hooks/useCalculator";
import type { Calc } from "../../types";
import styles from "./AcceptedPaymentTypes.module.css";

export const AcceptedPaymentTypes = () => {
  const config = useCalculator((state) => state.config);

  return (
    <div className={styles.list}>
      <div className={styles.label}>
        <Trans>Accepting:</Trans>
      </div>
      {config.paymentTypes.map((type, index) => (
        <AcceptedPaymentType key={index} type={type} />
      ))}
    </div>
  );
};

const AcceptedPaymentType: React.FC<{
  type: Calc.Calculator.PaymentType;
}> = ({ type }) => {
  switch (type) {
    case "card":
      return (
        <div className={styles.type}>
          <Icon name="card_24px_semibold" />
          <div className={styles.title}>
            <Trans>Cards</Trans>
          </div>
        </div>
      );

    case "paypal":
      return (
        <div className={styles.type}>
          <Icon name="paypal_24px_semibold" />
          <div className={styles.title}>
            <Trans>Paypal</Trans>
          </div>
        </div>
      );

    case "crypto":
      return (
        <div className={styles.type}>
          <Icon name="bitcoin_24px_regular" />
          <div className={styles.title}>
            <Trans>Crypto</Trans>
          </div>
        </div>
      );
  }
};
